/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initRevolveMagazine;
/* harmony export (immutable) */ __webpack_exports__["d"] = initStoryBars;
/* harmony export (immutable) */ __webpack_exports__["c"] = initSkipLinks;
/* harmony export (immutable) */ __webpack_exports__["a"] = onDomReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__ = __webpack_require__(11);


var STORY_BAR_CLASS = 'revolve-magazine__story-bar';
var SELECTORS = {
  root: '.js-revolve-magazine',
  toggle: '.js-revolve-magazine-toggle',
  contents: '.js-revolve-magazine-contents',
  close: '.js-revolve-magazine-close',
  // Structural to the component rather than js- hooks: the bars are addressed
  // by position inside the magazine root, which already scopes them.
  spread: '.revolve-magazine__spread',
  storyBar: ".".concat(STORY_BAR_CLASS)
};
var OPEN_CLASS = 'is-open';
var ROOT_OPEN_CLASS = 'revolve-magazine--contents-open';
var ROOT_STORY_BARS_CLASS = 'revolve-magazine--story-bars';
var LIVE_BAR_CLASS = "".concat(STORY_BAR_CLASS, "--live");
var EMPTY_CLASS = 'is-empty';

// Sub-pixel slack, so a spread counts as under the bar the moment its top
// reaches the line instead of a fraction of a pixel later.
var DOCK_EPSILON = 1;

// The shell's skip links, keyed by the hash they ship with. The magazine has
// no search box, and its main/footer regions are not the shell's.
var SKIP_LINKS = {
  hide: ['#search_term_new'],
  retarget: {
    '#main-content': '#main-content-magazine',
    '#site-footer': '#site-footer-magazine'
  }
};

/**
 * Progressive enhancement for the magazine page: turns the "contents" anchor
 * into an off-canvas drawer toggle. The spreads and their links are
 * server-rendered and handled with native CSS; the per-story title bars are
 * still natively sticky but their visibility is driven by `initStoryBars`.
 * While the drawer is open, Tab is kept inside it via the styleguide Keyboard
 * module. That pulls in jQuery (an external on the window), so this bundle
 * has to load after it - it is deferred behind chrome.js.
 *
 * @param {ParentNode} [scope=document] Where to look for the magazine root.
 * @return {Object|null} Controller API, or null when there is no magazine.
 */
function initRevolveMagazine() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var root = scope.querySelector(SELECTORS.root);
  if (!root) return null;
  var toggle = root.querySelector(SELECTORS.toggle);
  var contents = root.querySelector(SELECTORS.contents);
  var closeControl = root.querySelector(SELECTORS.close);
  var open = false;
  function setOpen(nextOpen) {
    var wasOpen = open;
    open = Boolean(nextOpen);
    if (contents) contents.classList.toggle(OPEN_CLASS, open);
    root.classList.toggle(ROOT_OPEN_CLASS, open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (open) {
      if (!wasOpen && contents) __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].trapFocus(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(contents));
      if (closeControl) closeControl.focus();
    } else if (wasOpen && contents) {
      // Hand focus back to the toggle only if it was still inside the drawer,
      // so a dismissal from elsewhere on the page keeps its own focus.
      var focusWasInside = toggle && contents.contains(document.activeElement);
      __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].releaseFocus(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(contents), focusWasInside ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggle) : null);
    }
  }
  function onToggleClick(event) {
    event.preventDefault();
    setOpen(!open);
  }
  function onCloseClick(event) {
    event.preventDefault();
    setOpen(false);
  }
  function onContentsClick(event) {
    var link = event.target.closest('a[href^="#"]');
    if (link && !link.matches(SELECTORS.close)) setOpen(false);
  }
  function onKeydown(event) {
    if (open && (event.key === 'Escape' || event.key === 'Esc')) setOpen(false);
  }
  function onRootClick(event) {
    // Dismiss on the scrim. The scrim is the root's own ::before, so a click
    // on it hit-tests to the root element itself - and since the scrim covers
    // the viewport above everything except the drawer, a click that reports
    // the root as its target can only have landed there.
    if (open && event.target === root) setOpen(false);
  }
  if (toggle) toggle.addEventListener('click', onToggleClick);
  if (closeControl) closeControl.addEventListener('click', onCloseClick);
  if (contents) contents.addEventListener('click', onContentsClick);
  root.addEventListener('click', onRootClick);
  document.addEventListener('keydown', onKeydown);
  return {
    open: function open() {
      return setOpen(true);
    },
    close: function close() {
      return setOpen(false);
    },
    isOpen: function isOpen() {
      return open;
    },
    destroy: function destroy() {
      if (contents) __WEBPACK_IMPORTED_MODULE_1_styleguide_modules_keyboard__["a" /* default */].releaseFocus(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(contents));
      if (toggle) toggle.removeEventListener('click', onToggleClick);
      if (closeControl) closeControl.removeEventListener('click', onCloseClick);
      if (contents) contents.removeEventListener('click', onContentsClick);
      root.removeEventListener('click', onRootClick);
      document.removeEventListener('keydown', onKeydown);
    }
  };
}

/**
 * One live title bar for the whole issue. The bars the server renders into
 * each spread leave the flow once this runs (see _rm-spread.scss) and a single
 * bar pinned under the banner shows the title of whichever story sits beneath
 * its bottom edge, swapping its content in place as the reader scrolls.
 * Nothing pushes anything: a new story simply changes what the bar says, and a
 * story with no bar of its own (the editor's letter) blanks it.
 *
 * Reading rects on scroll rather than using IntersectionObserver sentinels: an
 * issue is a couple of dozen spreads, the work is one rect per spread behind a
 * rAF, and "which spread is under the bar" stays a single readable expression.
 *
 * @param {ParentNode} [scope=document] Where to look for the magazine root.
 * @return {Object|null} Controller API, or null when there are no story bars.
 */
function initStoryBars() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var root = scope.querySelector(SELECTORS.root);
  if (!root) return null;

  // Every spread, with or without a bar: a story that has none still has to
  // blank the live bar while it is the one being read.
  var spreads = Array.prototype.slice.call(root.querySelectorAll(SELECTORS.spread)).map(function (spread) {
    return {
      spread: spread,
      bar: spread.querySelector(SELECTORS.storyBar)
    };
  });
  if (!spreads.some(function (pair) {
    return pair.bar;
  })) return null;
  var live = document.createElement('div');
  live.className = "".concat(STORY_BAR_CLASS, " ").concat(LIVE_BAR_CLASS, " ").concat(EMPTY_CLASS);
  // Ahead of the first spread, so it comes before the pages in the tab order.
  spreads[0].spread.parentNode.insertBefore(live, spreads[0].spread);

  // Claim the behaviour only once it is known to be wired up. Without this
  // class the stylesheet keeps each spread's own bar, sticky, which is the
  // right place for a page whose JS never arrives to end up.
  root.classList.add(ROOT_STORY_BARS_CLASS);
  var current = null;

  /**
   * Puts `pair`'s bar content into the live bar, or blanks it when the story
   * under the bar has none. Copies rather than moves: each section's
   * aria-labelledby points at its own heading, so that has to stay where it
   * is. Ids come off the copy so the page never holds two of the same.
   * @param {Object|null} pair The spread now under the bar, if any.
   */
  function show(pair) {
    if (pair === current) return;
    current = pair;
    while (live.firstChild) live.removeChild(live.firstChild);
    if (!pair || !pair.bar) {
      live.classList.add(EMPTY_CLASS);
      return;
    }
    Array.prototype.forEach.call(pair.bar.children, function (child) {
      var copy = child.cloneNode(true);
      copy.removeAttribute('id');
      Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (el) {
        el.removeAttribute('id');
      });
      live.appendChild(copy);
    });
    live.classList.remove(EMPTY_CLASS);
  }
  function render() {
    // The bar is fixed under the banner and only ever blanked with visibility,
    // so its box is always there to measure. Its bottom edge is the line: the
    // story under the bar is the one whose spread straddles it.
    var line = live.getBoundingClientRect().bottom;

    // Every rect is read before anything is written, so a frame's work is a
    // single layout pass.
    var rects = spreads.map(function (_ref) {
      var spread = _ref.spread;
      return spread.getBoundingClientRect();
    });
    var under = null;
    rects.forEach(function (rect, index) {
      if (rect.top <= line + DOCK_EPSILON && rect.bottom > line) under = spreads[index];
    });
    show(under);
  }
  var frame = null;
  function schedule() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(function () {
      frame = null;
      render();
    });
  }
  render();
  window.addEventListener('scroll', schedule, {
    passive: true
  });
  window.addEventListener('resize', schedule);
  return {
    /** Re-reads the layout and repaints, for use after a layout change. */
    refresh: render,
    destroy: function destroy() {
      if (frame !== null) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      root.classList.remove(ROOT_STORY_BARS_CLASS);
      if (live.parentNode) live.parentNode.removeChild(live);
    }
  };
}

/**
 * Aims the shell's skip links at the magazine's own landmarks. The header
 * markup is shared with every other page and cannot be edited for this one,
 * so the links are adjusted after the fact: the search skip link is hidden
 * and the main/footer ones are re-pointed. The focusTo plugin reads the hash
 * at click time, so a changed href is all it needs. A link is only re-pointed
 * when its magazine target exists, so it never ends up skipping to nowhere.
 *
 * @param {ParentNode} [scope=document] Where to look for the skip links.
 * @return {Object} Controller API whose `destroy` puts the links back.
 */
function initSkipLinks() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var hidden = [];
  var retargeted = [];
  SKIP_LINKS.hide.forEach(function (hash) {
    Array.prototype.forEach.call(scope.querySelectorAll("a[href=\"".concat(hash, "\"]")), function (link) {
      // `hidden` says what is meant; the inline display is what makes it
      // stick, since the .btn display rule would beat the attribute alone.
      link.setAttribute('hidden', '');
      link.style.setProperty('display', 'none');
      hidden.push(link);
    });
  });
  Object.keys(SKIP_LINKS.retarget).forEach(function (from) {
    var to = SKIP_LINKS.retarget[from];
    if (!scope.querySelector(to)) return;
    Array.prototype.forEach.call(scope.querySelectorAll("a[href=\"".concat(from, "\"]")), function (link) {
      link.setAttribute('href', to);
      retargeted.push({
        link: link,
        from: from
      });
    });
  });
  return {
    destroy: function destroy() {
      hidden.forEach(function (link) {
        link.removeAttribute('hidden');
        link.style.removeProperty('display');
      });
      retargeted.forEach(function (_ref2) {
        var link = _ref2.link,
          from = _ref2.from;
        return link.setAttribute('href', from);
      });
    }
  };
}

/**
 * Runs `callback` once the DOM is parsed. Fires immediately if it already is.
 * @param {Function} callback
 */
function onDomReady(callback) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, {
      once: true
    });
    return;
  }
  callback();
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SELECTORS */
/* unused harmony export EXPANDED_CLASS */
/* unused harmony export DEFAULT_VISIBLE */
/* unused harmony export initViewMoreBlock */
/* harmony export (immutable) */ __webpack_exports__["a"] = initViewMore;
/**
 * Keeps the first N children of a grid visible and reveals the rest behind a
 * "View More" / "View Less" toggle.
 *
 * Deliberately counts children rather than measuring height: the editorial grid
 * is a CSS grid whose rows vary in height, and hiding whole tiles keeps the
 * grid's own `repeat(6, 1fr)` columns doing the layout work. Dependency-free
 * because it ships in a critical bundle that may run before jQuery.
 *
 * @module viewMore
 */

var SELECTORS = {
  root: '.js-view-more',
  items: '.js-view-more-items',
  toggle: '.js-view-more-toggle'
};
var EXPANDED_CLASS = 'is-expanded';
var DEFAULT_VISIBLE = 6;
var ATTRIBUTES = {
  visible: 'data-view-more-visible',
  expandLabel: 'data-view-more-label',
  collapseLabel: 'data-view-less-label'
};
var DEFAULT_LABELS = {
  expand: 'View More',
  collapse: 'View Less'
};

/**
 * Reads how many children stay visible while collapsed, falling back to the
 * default when the attribute is missing or not a usable number.
 * @param {HTMLElement} root
 * @return {number}
 */
function visibleCount(root) {
  var parsed = parseInt(root.getAttribute(ATTRIBUTES.visible), 10);
  return parsed > 0 ? parsed : DEFAULT_VISIBLE;
}

/**
 * Wires up a single view-more block.
 * @param {HTMLElement} root An element matching `SELECTORS.root`.
 * @return {Object|null} Controller API, or null when the block is incomplete.
 */
function initViewMoreBlock(root) {
  var items = root.querySelector(SELECTORS.items);
  var toggle = root.querySelector(SELECTORS.toggle);
  if (!items || !toggle) return null;
  var visible = visibleCount(root);
  var labels = {
    expand: toggle.getAttribute(ATTRIBUTES.expandLabel) || DEFAULT_LABELS.expand,
    collapse: toggle.getAttribute(ATTRIBUTES.collapseLabel) || DEFAULT_LABELS.collapse
  };
  var children = Array.prototype.slice.call(items.children);
  // Nothing to reveal: leave every tile in place and drop the toggle. Also the
  // state a page whose JS never runs is left in.
  var _overflows = children.length > visible;
  var expanded = false;
  function render() {
    children.forEach(function (child, index) {
      child.hidden = !expanded && _overflows && index >= visible;
    });
    root.classList.toggle(EXPANDED_CLASS, expanded);
    toggle.hidden = !_overflows;
    toggle.textContent = expanded ? labels.collapse : labels.expand;
    toggle.setAttribute('aria-expanded', String(expanded));
  }
  function setExpanded(nextExpanded) {
    expanded = Boolean(nextExpanded) && _overflows;
    render();
  }
  function onToggleClick(event) {
    event.preventDefault();
    setExpanded(!expanded);

    // Collapsing can leave the toggle above the fold with the page scrolled
    // past it, so pull it back into view.
    if (!expanded) {
      root.scrollIntoView({
        block: 'nearest'
      });
      toggle.focus({
        preventScroll: true
      });
    }
  }
  toggle.addEventListener('click', onToggleClick);
  render();
  return {
    expand: function expand() {
      return setExpanded(true);
    },
    collapse: function collapse() {
      return setExpanded(false);
    },
    isExpanded: function isExpanded() {
      return expanded;
    },
    overflows: function overflows() {
      return _overflows;
    },
    destroy: function destroy() {
      toggle.removeEventListener('click', onToggleClick);
      root.classList.remove(EXPANDED_CLASS);
      children.forEach(function (child) {
        child.hidden = false;
      });
      toggle.hidden = false;
    }
  };
}

/**
 * Wires up every view-more block under `scope`.
 * @param {ParentNode} [scope=document] Where to look for blocks.
 * @return {Array<Object>} One controller per block that was wired up.
 */
function initViewMore() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  return Array.prototype.slice.call(scope.querySelectorAll(SELECTORS.root)).map(initViewMoreBlock).filter(Boolean);
}

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__revolve_magazine_scss__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__revolve_magazine_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__revolve_magazine_scss__);


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styleguide_styleguide_critical_revolve_magazine__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_revolve_magazine__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_view_more__ = __webpack_require__(2);



__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_revolve_magazine__["a" /* onDomReady */])(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_revolve_magazine__["b" /* initRevolveMagazine */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_revolve_magazine__["c" /* initSkipLinks */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_modules_revolve_magazine__["d" /* initStoryBars */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_modules_view_more__["a" /* default */])();
});

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Keyboard JS
 * Parses keyboard events
 * Trap the focus in the given element
 */


var keyCodes = {
  8: 'BACKSPACE',
  9: 'TAB',
  13: 'ENTER',
  27: 'ESCAPE',
  32: 'SPACE',
  37: 'ARROWLEFT',
  38: 'ARROWUP',
  39: 'ARROWRIGHT',
  40: 'ARROWDOWN'
};
var keyDirections = ['UP', 'RIGHT', 'DOWN', 'LEFT'];
/*
 * Constants for easier comparing.
 * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
 */
var getKeyCodes = function getKeyCodes(kcs) {
  var k = {};
  Object.keys(kcs).forEach(function (key) {
    k[kcs[key]] = kcs[key];
  });
  return k;
};
var Keyboard = {
  keys: getKeyCodes(keyCodes),
  /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */
  parseKey: function parseKey(event) {
    var key;
    if (event.key !== undefined) {
      key = event.key.toUpperCase();
      if (key === " " || event.which === 32) {
        key = 'SPACE';
      }
      if (key === 'ESC') {
        key = 'ESCAPE';
      }
      if (keyDirections.indexOf(key) > -1) {
        key = "ARROW".concat(key);
      }
    } else {
      key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    }

    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, '');
    if (event.shiftKey) key = "SHIFT_".concat(key);
    if (event.ctrlKey) key = "CTRL_".concat(key);
    if (event.altKey) key = "ALT_".concat(key);

    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, '');
    return key;
  },
  /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $el - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$el`
   */
  findFocusable: function findFocusable($el) {
    // only have visible elements and those that have a tabindex greater or equal 0
    return $el.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible').filter(function (index, el) {
      return el.getAttribute('tabindex') >= 0;
    });
  },
  /**
   * Traps the focus in the given element.
   * @param  {jQuery} $el - jQuery object to trap the foucs into.
   */
  trapFocus: function trapFocus($el) {
    $el.on('keydown.trapfocus', function (event) {
      var parsedKey = Keyboard.parseKey(event);
      if (parsedKey === 'TAB' || parsedKey === 'SHIFT_TAB') {
        // New element might be loaded. If the target is the same as the last,
        // attempt to rerun trapFocus Logic.
        var $focusable = Keyboard.findFocusable($el);
        var $firstFocusable = $focusable.eq(0);
        var $lastFocusable = $focusable.eq(-1);
        if (parsedKey === 'TAB' && event.target === $lastFocusable[0]) {
          event.preventDefault();
          $firstFocusable.focus();
        } else if (parsedKey === 'SHIFT_TAB') {
          if (event.target === $firstFocusable[0]) {
            event.preventDefault();
            $lastFocusable.focus();
          }
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(event.target, $focusable) === -1) {
            $lastFocusable.focus();
          }
        }
      }
    });
  },
  /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $el  jQuery object to release the focus for.
   * @param  {jQuery} $lastFocus return to last focus
   */
  releaseFocus: function releaseFocus($el, $lastFocus) {
    $el.off('keydown.trapfocus');
    if ($lastFocus) {
      $lastFocus.focus();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/revolve-magazine.js